import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Bubble, LoaderButton, ContinueLabel } from 'ctia-ui';
import LabTestInfo from 'containers/request/Initial/LabTestInfo';
import LabTestResult from 'containers/request/Initial/LabTestResult';
import { saveRequest } from 'actions/request';
import { submitWizardStep } from 'actions/wizard';

class LabInfo extends Component {
  validate() {
    const { cdmaLab } = this.props.request;
    // return cdmaLab > 0 && (cdmaLabPoc > 0 || cdmaLabPoc === '');
    return cdmaLab > 0;
  }

  render() {
    const {
      show,
      request,
      isEditable,
      canSave,
      canSubmit,
      saveRequest,
      submitWizardStep,
      wizard
    } = this.props;

    if (!show) return null;

    return (
      <div>
        <Bubble show={true}>Please select a lab for testing.</Bubble>
        <LabTestInfo editable={isEditable} />
        <hr />
        <LabTestResult testTitle="WINNF-TS-0122" />
        <div className="text-right">
          <LoaderButton
            disabled={!this.validate()}
            bsStyle="default"
            text="Save changes"
            isLoading={request.isLoading}
            onClick={saveRequest}
            show={canSave}
          />
          <LoaderButton
            disabled={!this.validate()}
            bsStyle="info"
            text={<ContinueLabel />}
            isLoading={request.isLoading}
            onClick={() => submitWizardStep(wizard)}
            show={canSubmit}
          />
        </div>
      </div>
    );
  }
}

LabInfo.propTypes = {
  show: PropTypes.bool,
  canSave: PropTypes.bool,
  canSubmit: PropTypes.bool
};

LabInfo.defaultProps = {
  show: true,
  canSave: false,
  canSubmit: false
};

function mapStateToProps({ request, wizard }) {
  return { request, wizard };
}

export default connect(
  mapStateToProps,
  {
    saveRequest,
    submitWizardStep
  }
)(LabInfo);



// WEBPACK FOOTER //
// ./src/containers/request/ECO/LabInfo.js